// src/FileIcon.tsx
import { jsx } from "react/jsx-runtime";
var FileIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "16",
    height: "21",
    viewBox: "0 0 16 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M14 20.5664H2C0.89543 20.5664 0 19.671 0 18.5664V2.56641C0 1.46184 0.89543 0.566406 2 0.566406H9C9.0109 0.566879 9.02167 0.568899 9.032 0.572406C9.04177 0.575423 9.05182 0.577434 9.062 0.578406C9.15019 0.584059 9.23726 0.601204 9.321 0.629406L9.349 0.638406C9.37167 0.646088 9.39373 0.655447 9.415 0.666406C9.52394 0.71483 9.62321 0.782591 9.708 0.866406L15.708 6.86641C15.7918 6.95119 15.8596 7.05046 15.908 7.15941C15.918 7.18141 15.925 7.20441 15.933 7.22741L15.942 7.25341C15.9699 7.3368 15.9864 7.42359 15.991 7.51141C15.9926 7.52059 15.9949 7.52962 15.998 7.53841C15.9998 7.54763 16.0004 7.55703 16.0001 7.56641V18.5664C16.0001 19.671 15.1046 20.5664 14 20.5664ZM2 2.56641V18.5664H14V8.56641H9C8.44772 8.56641 8 8.11869 8 7.56641V2.56641H2ZM10 3.98041V6.56641H12.586L10 3.98041Z" })
  }
);
var FileIcon_default = FileIcon;

export {
  FileIcon_default
};
